import { TeamViewRejectLeavePageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { useCalendarLeaves } from 'modules/calendar/hooks/useCalendarLeaves'
import RejectLeave from 'modules/timeoff/components/RejectLeave'
import { useOnCloseTeamView } from 'modules/timeoff/hooks/useOnCloseTeamView'

const TeamViewRejectLeavePage = () => {
  const { leave_id: leaveId } = useStrictParams<'leave_id'>()
  const onClose = useOnCloseTeamView()
  const { onChangeLeave } = useCalendarLeaves()

  const { data } = useQuery(TeamViewRejectLeavePageDocument, {
    variables: {
      leaveId: parseInt(leaveId, 10),
    },
  })

  const leaveEmployee = data?.timeoff.leave?.employee

  if (!leaveEmployee) {
    throw new Error('Leave employee not found')
  }

  return (
    <RejectLeave
      leaveId={parseInt(leaveId, 10)}
      onClose={onClose}
      onRejected={onChangeLeave}
      leaveEmployeeId={leaveEmployee.id}
    />
  )
}

export default TeamViewRejectLeavePage
